// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes j3o4L{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:translateY(0)}}.nBU9j{display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%;height:100%;box-sizing:border-box;padding:32px;text-align:center}.tzAA7{animation:j3o4L 600ms ease-out both}.JqLeL{width:240px;height:180px}.PTWT5{margin-top:4px}.X_18z{margin-top:8px}.QiwpL{margin-top:32px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen": `nBU9j`,
	"gradualReveal": `tzAA7`,
	"gradualRevealKeyframes": `j3o4L`,
	"lottieIcon": `JqLeL`,
	"subtitle": `PTWT5`,
	"description": `X_18z`,
	"buttons": `QiwpL`
};
export default ___CSS_LOADER_EXPORT___;
